import { Monitor, Users } from "lucide-react";
import { Field, input } from "./StepDetails";
import { moneyShort } from "../../lib/format";

const MODES = [["in_person", "In-Person", Users], ["virtual", "Virtual", Monitor]];

export default function StepPreferences({ form, set, errors, category, event }) {
  const modes = MODES.filter(([m]) => (category?.attendance_modes || event.attendance_modes).includes(m));
  return (
    <fieldset data-testid="step-preferences">
      <legend className="text-2xl text-navy"><span className="text-burgundy">3.</span> Attendance & Preferences</legend>
      <p className="mt-4 field-label" id="mode-label">Attendance Mode <span className="text-burgundy" aria-hidden="true">*</span></p>
      <div className="grid gap-4 sm:grid-cols-2" role="radiogroup" aria-labelledby="mode-label">
        {modes.map(([m, label, Ico]) => {
          const on = form.attendance_mode === m;
          return (
            <button key={m} type="button" role="radio" aria-checked={on} onClick={() => set({ attendance_mode: m })} data-testid={`attendance-mode-${m}`}
              className={`flex items-center gap-4 rounded-lg border-2 p-4 text-left transition-colors duration-200 ${on ? "border-burgundy bg-[#FEF3F3]" : "border-slate-200 hover:border-slate-400"}`}>
              <Ico className="text-navy" aria-hidden="true" />
              <span><b className="block text-navy">{label}</b>
                <span className="text-sm text-[#4A5568]">{category ? moneyShort(category.current_tier?.price ?? category.prices[m], category.currency) : ""}{m === "in_person" ? ` · ${event.venue_city}` : " · Online access"}</span></span>
            </button>
          );
        })}
      </div>
      {errors.attendance_mode && <p className="field-error" role="alert">{errors.attendance_mode}</p>}
      <div className="mt-6 grid gap-5 sm:grid-cols-2">
        <Field id="dietary" label="Dietary Requirements" hint="For in-person attendees."><input {...input(form, set, errors, "dietary", { maxLength: 300 })} /></Field>
        <Field id="accessibility" label="Accessibility Needs"><input {...input(form, set, errors, "accessibility", { maxLength: 300 })} /></Field>
        <div className="sm:col-span-2"><Field id="special_requests" label="Special Requests">
          <textarea rows={4} {...input(form, set, errors, "special_requests", { maxLength: 1000 })} /></Field></div>
      </div>
    </fieldset>
  );
}
